import { KeyboardEventHandler } from 'react'

import { allowedInputNumberKeys } from '@acre/utils'

export const preventNonNumericChars: KeyboardEventHandler<HTMLInputElement> = (evt) => {
  const hasAllowedChars = evt.metaKey || allowedInputNumberKeys.indexOf(evt.key) > -1

  if (!hasAllowedChars) evt.preventDefault()
}
